import { Avatar, Tooltip } from "@mantine/core";

export default function UserAvatar({ profile }) {
  var initials = () =>
    profile?.firstName?.charAt(0) + profile?.lastName?.charAt(0) || "";

  var name = () => {
    if (!profile) return "Unknown User";

    let name = profile.firstName ?? "";
    if (name && profile.lastName) name += " ";
    if (profile.lastName) name += profile.lastName;
    if (!name) return "Unknown User";
    return name;
  };

  return (
    <Avatar
      src={profile.profileImageUrl}
      name={name()}
      color="initials"
      size="md"
      radius="xl"
    ></Avatar>
  );
}
